import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ICardImageContent, ICarouselElement } from '../../../interfaces/carousel-element.interface';
import { CardWithImageComponent } from '../card-with-image/card-with-image.component';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-carousel-card',
  templateUrl: './carousel-card.component.html',
  standalone: true,
  imports: [CardWithImageComponent, CommonModule],
  styleUrls: ['./carousel-card.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CarouselCardComponent implements OnInit, OnChanges {
  @Input() carouselElements?: ICarouselElement;
  @Output() carouselEmitter: EventEmitter<string> = new EventEmitter();
  currentCarouselCard?: ICardImageContent;
  currentIndex: number = 0;
  isPreviewMode: boolean = false;

  constructor(private router : Router) {}

  ngOnInit() {
    this.isPreviewMode = this.router.url.startsWith('/preview-page');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['carouselElements']) {
      this.currentCarouselCard = this.carouselElements?.cardsContent[0];
    }
  }

  protected actionButton(id: string): void {
    this.carouselEmitter.emit(id);
  }

  protected previous(): void {
    if (this.carouselElements) {
      if (this.currentIndex % this.carouselElements?.cardsContent.length > 0) {
        this.currentIndex--;
        this.currentCarouselCard = this.carouselElements?.cardsContent[this.currentIndex];
      }
    }
  }

  protected next(): void {
    if (this.carouselElements) {
      if (this.currentIndex % this.carouselElements?.cardsContent.length < this.carouselElements?.cardsContent.length - 1) {
        this.currentIndex++;
        this.currentCarouselCard = this.carouselElements?.cardsContent[this.currentIndex];
      }
    }
  }
}
